import {
  ADD_AUTO_CLIP_TO_USER,
  DELETE_CLIP,
  DOWNLOAD_CLIP,
  GET_ALL_CLIPS,
  GET_ALL_CLIPS_FOR_ID,
  GET_ALL_EVENTS_WITH_CLIPS,
  GET_EVENT_AUTO_CLIPS,
  GET_SHARED_CLIP,
  SEND_CLIP,
} from '../actionTypes';
import api from '../../api/api';
import {
  UPDATE_CLIPS,
  UPDATE_ALL_CLIPS,
  UPDATE_AUTO_CLIPS,
} from '../mutationTypes';

export default {
  [SEND_CLIP]: async ({dispatch}, {
    event,
    name,
    start,
    duration,
    tags,
    streamId,
  }) => {
    const params = {
      event_id: event,
      name,
      start_time: start,
      duration,
      tags,
      event_media_id: streamId,
    };

    const request = await api.clipApi.send_clip(params);
    dispatch(GET_ALL_CLIPS_FOR_ID, {
      id: event,
    });
    return request;
  },
  [GET_ALL_CLIPS_FOR_ID]: async ({commit}, params) => {
    const response = await api.clipApi.get_clips_for_id(params);
    commit(UPDATE_CLIPS, response);
    return response;
  },
  [DOWNLOAD_CLIP]: (_, params) => {
    return api.clipApi.downloadClip(params);
  },
  [GET_SHARED_CLIP]: (_, params) => {
    return api.clipApi.get_shared_clip(params);
  },
  [DELETE_CLIP]: async ({dispatch}, params) => {
    return await api.clipApi.delete_clip(params);
  },
  [GET_ALL_CLIPS]: async ({commit}) => {
    const {data} = await api.clipApi.get_all_clips();
    commit(UPDATE_ALL_CLIPS, data || []);
    return data;
  },
  [GET_ALL_EVENTS_WITH_CLIPS]: () => {
    return api.clipApi.get_events_with_clips();
  },
  [GET_EVENT_AUTO_CLIPS]: async ({commit}, {id} = {}) => {
    try {
      const {data} = await api.clipApi.getAutoClipsForEvent({id});
      commit(UPDATE_AUTO_CLIPS, data);
      return data;
    } catch (e) {
      console.error('GET_EVENT_AUTO_CLIPS', e);
    }
  },
  [ADD_AUTO_CLIP_TO_USER]: (_, {id} = {}) => {
    return api.clipApi.addAutoClipToUserList({id});
  },
};
